import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import {
  RespondentResponseSubmitDto,
  RespondentSurveyDto
} from '../models';
import {
  getMockRespondentSurvey,
  saveMockRespondentResponses
} from '../../mock/work-environment-survey.mock-data';

/**
 * The respondent's own view of a survey — the one screen that is reached
 * without logging in, using the token from the invitation link.
 *
 * NOT YET CONNECTED TO THE BACKEND (#6073). Mock bodies, real signatures.
 *
 * Note for whoever wires this up: these two calls are unauthenticated, so the
 * respondent token is the only thing standing between a caller and the
 * survey. The interceptor sends cookies and a CSRF header on every request,
 * which an anonymous caller does not have — check that the endpoints are
 * exempt from CSRF and that the token is single-purpose and unguessable.
 */
@Injectable()
export class RespondentSurveyService {
  private readonly API_BASE = `${environment.BASE_URL_V2}/work-environment-survey/respondent`;

  private readonly mockLatencyMs = 250;

  /**
   * The survey this respondent was invited to, with any answers already saved.
   *
   * GET {API_BASE}/{respondentId}/survey
   */
  getSurvey(respondentId: string): Observable<RespondentSurveyDto> {
    return of(getMockRespondentSurvey(respondentId)).pipe(
      delay(this.mockLatencyMs)
    );
  }

  /**
   * Save the answers for one category. Called each time the respondent moves
   * on, so a half-finished survey survives closing the tab.
   *
   * PATCH {API_BASE}/{respondentId}/responses
   */
  submitCategoryResponses(
    respondentId: string,
    responses: RespondentResponseSubmitDto[]
  ): Observable<void> {
    saveMockRespondentResponses(respondentId, responses);

    return of(undefined).pipe(delay(this.mockLatencyMs));
  }
}
